import { Modal } from "react-bootstrap";

import { ProgressBarLoading } from "@/modules/dwelling/containers/DwellingEstimateContainer/ProgressBarLoading/ProgressBarLoading.tsx";

export const ModalGenerateCostingLoading = ({
  currentValue,
  maxValue,
  showModal,
}: {
  currentValue: {
    valueProgress: number;
    step: string;
    index: number;
  };
  maxValue: number;
  showModal: boolean;
}) => {
  return (
    <Modal centered={true} size={"lg"} show={showModal}>
      <div
        style={{
          backgroundColor: "rgba(229,229,229,0.3)",
        }}
        className={
          "d-flex flex-column justify-content-center align-items-center py-5"
        }
      >
        <label className={"mb-4"}>Génération du chiffrage...</label>

        <ProgressBarLoading
          valueProgress={currentValue.valueProgress}
          maxValue={maxValue}
        />
        <span className={"mt-2"}>{currentValue.step}</span>
      </div>
    </Modal>
  );
};
